import { apiClient } from './apiClient';

export const getStoreSeats = async (storeId) => {
  return await apiClient(`/admin/management/stores/${storeId}/seats`, { method: 'GET' }, true);
};

export const updateStoreSeats = async (storeId, payload) => {
  return await apiClient(`/admin/management/stores/${storeId}/seats`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }, true);
};